import { useEffect, useRef, useState } from 'react'

const EXTRA_PX_TO_COMPENSATE_FLOATING_VALUES = 2

export const useMaxItemsDisplayed = (selectedIndexes: number[], maxMultiple?: number) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const chipWidthsRef = useRef<number[]>([])
  const hiddenCountChipWidthRef = useRef<number>(0)
  const [hiddenCount, setHiddenCount] = useState(0)
  const [width, setWidth] = useState<number>(0)

  // Get container width on mount and resize
  useEffect(() => {
    if (!maxMultiple) return
    const handleResize = () => {
      if (!containerRef.current) return
      setWidth(containerRef.current.offsetWidth)
    }

    handleResize() // Set initial size
    window.addEventListener('resize', handleResize) // Adjust on window resize

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [maxMultiple])

  // Calculate widths of all chips
  useEffect(() => {
    if (!containerRef.current || maxMultiple === undefined) return

    const childrenArray = Array.from(containerRef.current.children)
    const lastChild = childrenArray.pop() as HTMLElement
    const widths = childrenArray.map((child) => (child as HTMLElement).offsetWidth)

    chipWidthsRef.current = widths
    hiddenCountChipWidthRef.current = lastChild.offsetWidth
  }, [selectedIndexes, maxMultiple, containerRef])

  // Adjust visible children based on container width and chip widths
  useEffect(() => {
    if (!width || chipWidthsRef.current.length === 0 || maxMultiple === undefined) return

    let totalWidth = 0
    let visibleCount = 0

    for (let i = 0; i < chipWidthsRef.current.length; i++) {
      if (
        visibleCount >= maxMultiple ||
        totalWidth + chipWidthsRef.current[i] + hiddenCountChipWidthRef.current > width
      ) {
        break
      }
      totalWidth += chipWidthsRef.current[i] + EXTRA_PX_TO_COMPENSATE_FLOATING_VALUES
      visibleCount++
    }

    setHiddenCount(selectedIndexes.length - visibleCount)
  }, [width, maxMultiple, selectedIndexes.length])

  return { hiddenCount, containerRef }
}
